import VehicleDetail from 'scenes/VehicleDetail'

const routes = {
  detail: {
    path: '/vehiculos/:vehicleId/:section',
    breadcrumb: ' ',
    component: VehicleDetail,
  },
  detailhistory: {
    path: '/vehiculos/:vehicleId/:section/:claimId',
    breadcrumb: ' ',
    component: VehicleDetail,
  },
  // detaildatahistory: {
  //   path: '/vehiculos/:vehicleId/datossiniestro/:claimId',
  //   breadcrumb: ' ',
  //   component: VehicleDetail,
  // },
  // following routes will be ALWAYS ignored
  // since `detail` route matches first with `:section` param
  // these routes are defined here to navigate to specific part of detail page
  // and for backwards-compatibility

  // for current claim detail
  claimdata: {
    path: '/vehiculos/:vehicleId/datossiniestro',
    breadcrumb: 'Datos'
  },
  policy: {
    path: '/vehiculos/:vehicleId/poliza',
    breadcrumb: 'Polizas'
  },
  claim: {
    path: '/vehiculos/:vehicleId/siniestro',
    breadcrumb: 'Siniestros'
  },
  data: {
    path: '/vehiculos/:vehicleId/detalle',
    breadcrumb: 'Detalle'
  },
  drivers: {
    path: '/vehiculos/:vehicleId/conductores',
    breadcrumb: 'Conductores'
  },
  config: {
    path: '/vehiculos/:vehicleId/configuracion',
    breadcrumb: 'Configuracion'
  },


  // for historic claim detail
  claimdatahistoric: {
    path: '/vehiculos/:vehicleId/datossiniestro/:claimId',
    breadcrumb: 'Datos'
  },
  policyhistoric: {
    path: '/vehiculos/:vehicleId/poliza/:claimId',
    breadcrumb: 'Polizas'
  },
  claimhistoric: {
    path: '/vehiculos/:vehicleId/siniestro/:claimId',
    breadcrumb: 'Siniestros'
  },
  datahistoric: {
    path: '/vehiculos/:vehicleId/detalle/:claimId',
    breadcrumb: 'Detalle'
  },
  drivershistoric: {
    path: '/vehiculos/:vehicleId/conductores/:claimId',
    breadcrumb: 'Conductores'
  },
  confighistoric: {
    path: '/vehiculos/:vehicleId/configuracion/:claimId',
    breadcrumb: 'Configuracion'
  },

  
}

export default routes



// WEBPACK FOOTER //
// ./src/routes/vehicles.js